/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-dialog-body[_ngcontent-%COMP%]{height:338px}.app-dialog-body[_ngcontent-%COMP%]   .print_info[_ngcontent-%COMP%]{padding-left:24px;padding-right:24px}.mat-choice__container[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.mat-choice__container[_ngcontent-%COMP%]   .download-btn-label__content[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;line-height:1.1;font-weight:700}.mat-choice__container[_ngcontent-%COMP%]   .download-btn-label-icon[_ngcontent-%COMP%]{margin-bottom:16px}"];
export { styles as styles };
